import { render, staticRenderFns } from "./xeWorkgroupDetail.vue?vue&type=template&id=aba3c194"
import script from "./xeWorkgroupDetail.vue?vue&type=script&lang=js"
export * from "./xeWorkgroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports